import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/ministerio.png")